import React, { useState } from 'react';
import './Deporte.css';

const Deporte = () => {
  const [nombre, setNombre] = useState('');
  const [detalle, setDetalle] = useState('');

  const handleWhatsAppRedirect = () => {
    const mensaje =
`Hola! Quisiera consultar por el servicio de *Cobertura en Eventos Deportivos*.
Mi nombre es: ${nombre}

Evento (día, lugar, disciplina, etc.):
${detalle}`;
    const url = `https://wa.me/5491160035550?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  };

  const backgroundStyle = {
    backgroundImage: 'url("/images/polista-deporte.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    position: 'relative',
    width: '100%',
    height: '100%',
  };

  return (
    <div style={backgroundStyle} className="deporte-bg">
      <div
        className="deporte-overlay"
        style={{
          backgroundColor: 'rgba(237, 232, 227, 0.85)',
          backdropFilter: 'blur(1px)',
          minHeight: '100vh',
          paddingBottom: '2rem',
        }}
      >
        {/* Header */}
        <div className="deporte-header">
          <h1 className="deporte-title">Cobertura en Eventos Deportivos</h1>
          <p className="deporte-description">
            Ya sea un partido de fútbol, polo, rugby, surf o cualquier disciplina, ofrezco cobertura
            fotográfica completa del evento. Me encargo de capturar los momentos clave con equipos
            profesionales, edición personalizada y entrega en alta calidad.
          </p>
        </div>

        {/* Imagen superpuesta mitad header / mitad fondo */}
        <div className="deporte-imagen-descentrada">
          <img
            src="/images/deporte.jpg"
            alt="Cobertura fotográfica deportiva"
          />
        </div>

        <div className="deporte-container">
          {/* ¿Qué incluye? como cards con hover (sin numeritos) */}
          <div className="deporte-incluye">
            <h2>¿Qué incluye el servicio?</h2>
            <div className="deporte-cards">
              <div className="deporte-card" tabIndex={0} role="button">
                <span className="deporte-paso-num"></span>
                <p>Sesión presencial durante el evento deportivo</p>
              </div>
              <div className="deporte-card" tabIndex={0} role="button">
                <span className="deporte-paso-num"></span>
                <p>Captura de momentos clave: acción, emoción y detalles</p>
              </div>
              <div className="deporte-card" tabIndex={0} role="button">
                <span className="deporte-paso-num"></span>
                <p>Edición profesional y estilo personalizado</p>
              </div>
              <div className="deporte-card" tabIndex={0} role="button">
                <span className="deporte-paso-num"></span>
                <p>Entrega digital en alta calidad (JPG o TIFF)</p>
              </div>
            </div>
          </div>

          {/* CTA / Formulario */}
          <div className="deporte-cta-final">
            <h2>Consulta por este servicio</h2>
            <p>Contanos del evento y coordinamos cobertura a medida.</p>
            <div className="deporte-form">
              <input
                type="text"
                placeholder="Tu nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
              <textarea
                rows="4"
                placeholder="Contanos del evento deportivo (día, lugar, disciplina, etc.)"
                value={detalle}
                onChange={(e) => setDetalle(e.target.value)}
              />
            </div>
            <button onClick={handleWhatsAppRedirect}>Consultar por servicio</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deporte;
